/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Title_ShootInputs */

const en_home_hero_title_shoot = /** @type {(inputs: Home_Hero_Title_ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot.`)
};

const es_home_hero_title_shoot = /** @type {(inputs: Home_Hero_Title_ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispara.`)
};

const fr_home_hero_title_shoot = /** @type {(inputs: Home_Hero_Title_ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photographiez.`)
};

const de_home_hero_title_shoot = /** @type {(inputs: Home_Hero_Title_ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnehmen.`)
};

const ja_home_hero_title_shoot = /** @type {(inputs: Home_Hero_Title_ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撮影。`)
};

const zh_home_hero_title_shoot = /** @type {(inputs: Home_Hero_Title_ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拍摄。`)
};

const ar_home_hero_title_shoot = /** @type {(inputs: Home_Hero_Title_ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صوّر.`)
};

const id_home_hero_title_shoot = /** @type {(inputs: Home_Hero_Title_ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potret.`)
};

const it_home_hero_title_shoot = /** @type {(inputs: Home_Hero_Title_ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scatta.`)
};

const ru_home_hero_title_shoot = /** @type {(inputs: Home_Hero_Title_ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снимай.`)
};

const pt_home_hero_title_shoot = /** @type {(inputs: Home_Hero_Title_ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografe.`)
};

const ko_home_hero_title_shoot = /** @type {(inputs: Home_Hero_Title_ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`촬영.`)
};

/**
* | output |
* | --- |
* | "Shoot." |
*
* @param {Home_Hero_Title_ShootInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const home_hero_title_shoot = /** @type {((inputs?: Home_Hero_Title_ShootInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Title_ShootInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_title_shoot(inputs)
	if (locale === "es") return es_home_hero_title_shoot(inputs)
	if (locale === "fr") return fr_home_hero_title_shoot(inputs)
	if (locale === "de") return de_home_hero_title_shoot(inputs)
	if (locale === "ja") return ja_home_hero_title_shoot(inputs)
	if (locale === "zh") return zh_home_hero_title_shoot(inputs)
	if (locale === "ar") return ar_home_hero_title_shoot(inputs)
	if (locale === "id") return id_home_hero_title_shoot(inputs)
	if (locale === "it") return it_home_hero_title_shoot(inputs)
	if (locale === "ru") return ru_home_hero_title_shoot(inputs)
	if (locale === "pt") return pt_home_hero_title_shoot(inputs)
	return ko_home_hero_title_shoot(inputs)
});